import React, { useState, useEffect } from "react";

// AWS
import { API, Auth } from "aws-amplify";

function useGetLoanRequestCount({ setCountObj, ...query }) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(query);
  }, []);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const getData = async (where) => {
    try {
      setLoading(true);
      let lastItem = null;
      let datas = null;
      let count = 0;

      // var fetchNow = async function () {
      //   API.get("MoneyHubAdmin", "/loanRequest/count", {
      //     queryStringParameters: {
      //       ...where,
      //       ExclusiveStartKey: getLastItem(lastItem),
      //     },
      //     headers: {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     },
      //   }).then((response) => {
      //     lastItem = response?.body?.lastItem;
      //     countData += response?.body?.count;
      //     setDatas(countData);
      //     if (lastItem === null) {
      //       return;
      //     } else {
      //       fetchNow();
      //     }
      //   });
      // };

      // fetchNow();

      const controller = new AbortController();
      const signal = controller.signal;

      // console.log("checkSubmit", checkSubmit);

      do {
        datas = await API.get("MoneyHubAdmin", "/loanRequest/count", {
          queryStringParameters: {
            ...where,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          // signal,
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        // setDatas(count);
        setCountObj((prev) => {
          return {
            ...prev,
            [where.status]: count,
          };
        });
      } while (lastItem);

      const parseData = datas.body.Items;
      // setCount(count);
      // setDatas(count);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useGetLoanRequestCount;
